import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import cn from "classnames";
import { Button, ButtonProps } from "rsuite";

import { RootState } from "store/store";

import "./Footer.less";

interface Props {
    children?: React.ReactNode;
    className?: string;
    customButton?: React.ReactNode;
    saveButtonProps?: ButtonProps;

    onSubmit?: () => void;
}

const Footer: React.FC<Props> = ({
    children,
    className,
    customButton,
    saveButtonProps,
    onSubmit,
}: Props) => {
    const { t } = useTranslation();

    const isUnsavedChangeAvailable = useSelector(
        (state: RootState): boolean =>
            state.unsavedDataReducer.isUnsavedChangeAvailable
    );

    return (
        <div className={cn("footer", className)}>
            {customButton ?? (
                <Button
                    className="footer__save-btn"
                    appearance="primary"
                    disabled={!isUnsavedChangeAvailable}
                    onClick={onSubmit}
                    {...saveButtonProps}
                >
                    {t("tenantConfig.saveButton")}
                </Button>
            )}

            {children}
        </div>
    );
};

export default Footer;
